export class RelatoriosPersonalizadosFactory {
  constructor(instance) {
    this.instance = instance;
  }

  listRelatoriosPersonalizados(filter) {
    return this.instance.get('v1/financeiro/relatorios-personalizados', {
      params: filter || null,
    });
  }

  getRelatorioPersonalizado(id) {
    return this.instance.get(`v1/financeiro/relatorios-personalizados/${id}`);
  }

  insertRelatorioPersonalizado(data) {
    return this.instance.post('v1/financeiro/relatorios-personalizados', data);
  }

  editRelatorioPersonalizado(id, data) {
    return this.instance.put(
      `v1/financeiro/relatorios-personalizados/${id}`,
      data,
    );
  }

  removeRelatorioPersonalizado(id) {
    return this.instance.delete(
      `v1/financeiro/relatorios-personalizados/${id}`,
    );
  }

  executarRelatorioPersonalizado(id, filter) {
    return this.instance.get(
      `v1/financeiro/relatorios-personalizados/${id}/executar`,
      {
        params: filter || null,
      },
    );
  }
}

export default (...params) => new RelatoriosPersonalizadosFactory(...params);
